import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import { Text } from '../Elements';
import { calcPercent } from 'utils/common';

import classes from './TableParentTooltip.module.scss';

const TableParentTooltip = ({ data, title }) => {
  const unique = [...new Set(data)];
  const output = [];
  unique.map(item => {
    let count = 0;
    data.map(i => {
      if (i === item) ++count;
      return false;
    });
    output.push({
      name: item,
      value: count,
      percent: calcPercent(count, data.length)
    });
    return false;
  });

  return (
    <div className={classes.tooltip}>
      <Text className={classes.tooltip_text}>{title}</Text>
      <ul>
        {output.map(item => (
          <li className={classes.tooltip_item} key={item.name}>
            <Text className={cn(classes.tooltip_text, classes.tooltip_name)}>
              {`${item.name}:`}
            </Text>
            <Text className={classes.tooltip_text}>
              {`${item.value} (${item.percent}%)`}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
};

TableParentTooltip.propTypes = {
  data: PropTypes.arrayOf(PropTypes.string),
  title: PropTypes.string
};

export default TableParentTooltip;
